import { ReactElement } from 'react';
import { IonContent } from '@ionic/react';
import CupIcon from '../../assets/icons/CupIcon';
import PlateIcon from '../../assets/icons/PlateIcon';
import DiscountsIcon from '../../assets/icons/DiscountsIcon';
import useCashbackProgram from '../../../../hooks/cashback/useCashbackProgram';
import useAppMethods from '../../../../hooks/utility/useAppMethods';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/headers/PageHeader';

const RewardsPage = (): ReactElement => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Rewards:RewardsPage' });
  const { balance, cashbackProgram, hasCashbackProgram, calculateExpectedCashback, formatPointsAsMoney } =
    useCashbackProgram();
  const { formatCurrency } = useAppMethods();

  if (!hasCashbackProgram) {
    return null;
  }

  const rewards = calculateExpectedCashback(1);
  const amount = formatCurrency(1);
  const minRewardMoneyEq = formatPointsAsMoney(cashbackProgram?.min_spending_limit);

  const articles = [
    {
      title: t('content.articles.title'),
      description: t('content.articles.spend_description', { amount, rewards }),
      icon: <CupIcon className="stroke-brand-primary w-[40px] h-[47px]" />,
    },
    {
      title: t('content.articles.redeem_title'),
      description: t('content.articles.redeem_description', {
        amount: minRewardMoneyEq,
        minSpendingLimit: cashbackProgram?.min_spending_limit,
      }),
      icon: <PlateIcon className="stroke-brand-primary w-[40px] h-[47px]" />,
    },
    {
      title: t('content.articles.discounts_title'),
      description: t('content.articles.discounts_description'),
      icon: <DiscountsIcon className="stroke-brand-primary w-[40px] h-[47px]" />,
    },
  ];

  return (
    <>
      <PageHeader title={t('header.title')} />
      <IonContent className="min-h-[80dvh] [&::part(scroll)]:p-sm space-y-sm">
        <h3 className="text-md">{t('content.title', { balance })}</h3>
        <p className="text-muted-foreground text-sm font-semibold">{t('content.description', { amount, rewards })}</p>
        {articles.map(({ title, description, icon }, index) => (
          <article className="bg-mobile-notice bordered py-md !mt-6 flex space-x-md px-md" key={index}>
            <div className="w-fit shrink-0">{icon}</div>
            <div className="space-y-[2px]">
              <h6>{title}</h6>
              <p className="text-sm text-muted-foreground">{description}</p>
            </div>
          </article>
        ))}
      </IonContent>
    </>
  );
};

export default RewardsPage;
